<template>
  <router-view></router-view>
</template>

<script>
import { ElLoading, ElMessage } from "element-plus";
export default {
  methods: {
    // 初始化只读数据；临时失败重试一次，所有退出路径都释放加载遮罩。
    async initData() {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      try {
        let response;
        for (let attempt = 0; attempt < 2; attempt++) {
          try {
            response = await this.axios.post_form("/member/index/initdata", {});
            break;
          } catch (error) {
            const status = error.response && error.response.status;
            if (attempt === 1 || (status && status < 500)) throw error;
          }
        }
        const res = response.data;
        if (res.status != 200) throw new Error("Initialization rejected");
        this.$store.commit("setAuthority", res.data.authority);
        await this.$store.dispatch("updateUserAuthority");
        this.$store.commit("setService", res.data.service);
      } catch (error) {
        // 401 由统一请求拦截器跳转登录页，不重复提示或重试。
        if (!error.response || error.response.status !== 401) {
          ElMessage.error(this.$t("tips.loadfail"));
        }
      } finally {
        loadingInstance.close();
      }
    },
  },
  watch: {
    '$store.state.User.isLogin': {
      immediate: true,
      handler(isLogin) {
        if (!isLogin) return;
        this.initData();
        this.$store.dispatch("getPayPackage");
        this.$store.dispatch("getUpgradePackages");
      },
    },
  },
};
</script>

<style></style>
